'use client'
import { type ReactNode } from 'react'
import { globalStore } from 'globalStore'
import { Provider } from 'jotai'

export function LayoutJotaiProvider({ children }: { children: ReactNode }) {
  return <Provider store={globalStore}>{children}</Provider>
}
